import type { TFunction } from 'i18next'

/**
 * 呼び出し元 component が `t()` で解決する i18n key と、その補間値。
 * model は key と値までを返し、文字列への解決は component が行う
 * (`errorDetail.ts` と同じ分離)。
 */
export type InterpolatedMessage =
  | { key: string; rejectionCodes?: undefined; limit?: undefined }
  | {
      key: string
      /**
       * `{{codes}}` に入れる OCCTO の応答コード (AC-PLC-020-2 の {応答コード})。
       */
      rejectionCodes: readonly string[]
      limit?: undefined
    }
  | {
      key: string
      rejectionCodes?: undefined
      /** `{{limit}}` に入れる内訳の件数の上限 (AC-PLC-064)。 */
      limit: number
    }

/** 内訳の件数の上限を 3 桁区切りにする (AC-PLC-064 / `{{limit}}`)。 */
function formatBreakdownRowLimit(limit: number): string {
  return limit.toLocaleString('ja-JP')
}

/**
 * `InterpolatedMessage` を表示文字列にする。応答コードは locale の区切り
 * (ja「、」/ en「, 」) で連結して `{{codes}}` に入れる。
 */
export function translateInterpolatedMessage(
  t: TFunction,
  message: InterpolatedMessage,
): string {
  if (message.limit !== undefined) {
    return t(message.key, { limit: formatBreakdownRowLimit(message.limit) })
  }
  if (message.rejectionCodes === undefined) {
    return t(message.key)
  }
  return t(message.key, {
    codes: message.rejectionCodes.join(
      t('page:planSubmission.sendFailedCause.codeSeparator'),
    ),
  })
}
